<template>
    <div class="addBestellung container" id="frame">
        <h3 class="page-header">Blocker setzen</h3>

        <div class="jumbotron">
            <h4>Termindetails</h4>
            <div class="form-group">
                <label>Bezeichnung:</label>
                <input type="text" class="form-control" placeholder="Blocker" v-model="blockername" />
            </div>
            <div class="form-group">
                <label>Datum:</label>
                <input type="date" class="form-control" placeholder="Datum" v-model="bestellung.Datum" />
            </div>
            <div class="form-group">
                <label>Uhrzeit-Start:</label>
                <input type="time" class="form-control" placeholder="Uhrzeit" v-on:blur="setEndTime()" v-model="bestellung.Uhrzeit" />
                <label>Uhrzeit-Ende:</label>
                <input type="time" class="form-control" placeholder="Uhrzeit" v-model="bestellung.Enduhrzeit" />
            </div>
            <div class="form-group">
                <label>Wiederholung:</label>

                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="WiederholungCheck" id="WiederholungCheck1" value="0" v-model="rowtermin" />
                    <label class="form-check-label" for="SelbsteinkaeuferCheck1">einmalig</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="WiederholungCheck" id="WiederholungCheck2" value="1" v-model="rowtermin" />
                    <label class="form-check-label" for="WiederholungCheck2">wiederholen</label>
                </div>
            </div>
            <div v-if="rowtermin == 1">
                <v-select v-model="selectedFrequency" :items="rowterminFrequency" item-text="text" item-value="value" label="Frequenz" return-object attach> </v-select>
            </div>
        </div>

        <div class="alert alert-success" v-if="showAlarm">
            <span>
                <center>
                    <b>Reihenblocker wird eingetragen! Dies kann bis zu 2 Min. dauern.</b>
                    <br />
                    <v-progress-circular :size="70" :width="7" color="red" indeterminate></v-progress-circular>
                </center>
            </span>
        </div>

        <button :disabled="btnDisabled" v-on:click="addBlocker" class="btn btn-sm btn-success" id="buttonbottom">Speichern</button>
    </div>
</template>

<script>
    import _ from "lodash"
    const moment = require("moment")
    export default {
        name: "addBestellung",
        data() {
            return {
                auth: "Basic " + window.btoa(process.env.VUE_APP_NODE_AUTH),
                latestInvoice: "",
                btnDisabled: false,
                dbRechnung: 0,
                bestellung: {
                    Selbsteinkaeufer: 1,
                    Taschen: 0,
                    Kisten: 0,
                    Shop: 0,
                    Baecker: 0,
                    TK: 0,
                    Blumen: 0,
                    Fahrer: 1
                },
                rechnung: {
                    kundenNr: "",
                    wert: 0,
                    pauschale: 0,
                    datum: "",
                    typ: "Bar",
                    schicht: "Früh"
                },
                pauschalen: [
                    { text: "€ 0", value: 0 }
                    // {text: "€ 3", value: 3},
                    // {text: "€ 7", value: 7},
                    // {text: "€ X", value: "x" , xPauschale: 0},
                ],
                selectedPauschale: { text: "0 €", value: 0 },
                typen: ["Kredit", "Bar", "EC", "Retoure EC", "Retoure Bar", "Retoure Kredit"],
                schichten: ["Früh", "Spät"],
                xValue: 0,
                alarm: "",
                kunde: {},
                termin: {},
                rowtermin: 0,
                singletermin: 0,
                showAlarm: 0,
                rowterminFrequency: [
                    { text: "1 Jahr - wöchentlich", value: 0, cycles: 52, days: 7 },
                    { text: "1 Jahr - alle 2 Wochen", value: 1, cycles: 26, days: 14 },
                    { text: "1 Jahr - alle 4 Wochen", value: 2, cycles: 12, days: 28 },
                    { text: "2 Jahre - wöchentlich", value: 3, cycles: 104, days: 7 },
                    { text: "2 Jahre - alle 2 Wochen", value: 4, cycles: 52, days: 14 },
                    { text: "2 Jahre - alle 4 Wochen", value: 5, cycles: 24, days: 28 },
                    { text: "1 Monat - täglich", value: 6, cycles: 30, days: 1 },
                    { text: "3 Monate - täglich", value: 7, cycles: 90, days: 1 },
                    { text: "halbes Jahr - täglich", value: 7, cycles: 180, days: 1 },
                    { text: "1 Jahr - täglich", value: 8, cycles: 365, days: 1 }
                ],
                selectedFrequency: { text: "1 Jahr - wöchentlich", value: 0, cycles: 52, days: 7 },
                dst: [
                    { year: 2019, start: "2019-03-31", ende: "2019-10-27" },
                    { year: 2020, start: "2020-03-29", ende: "2020-10-25" },
                    { year: 2021, start: "2021-03-28", ende: "2021-10-31" },
                    { year: 2022, start: "2022-03-27", ende: "2022-10-30" },
                    { year: 2023, start: "2023-03-26", ende: "2023-10-29" },
                    { year: 2024, start: "2024-03-31", ende: "2024-10-27" },
                    { year: 2025, start: "2025-03-30", ende: "2025-10-26" },
                    { year: 2026, start: "2026-03-29", ende: "2026-10-25" },
                    { year: 2027, start: "2027-03-28", ende: "2027-10-31" },
                    { year: 2028, start: "2028-03-26", ende: "2028-10-29" },
                    { year: 2029, start: "2029-03-25", ende: "2029-10-28" }
                ],
                blockername: "Blocker"
            }
        },
        methods: {
            setEndTime() {
                var newEndtime = moment(this.bestellung.Uhrzeit, "HH:mm:ss").add(15, "minutes").format("HH:mm")

                this.bestellung.Enduhrzeit = newEndtime
                var value = this.rowtermin
                this.rowtermin = !value
                this.rowtermin = value
            },
            addBlocker() {
                if (this.bestellung.Uhrzeit < this.bestellung.Enduhrzeit && this.bestellung.Uhrzeit && this.bestellung.Enduhrzeit && this.bestellung.Datum) {
                    this.btnDisabled = true
                    let neueBestellung = {
                        Datum: this.bestellung.Datum,
                        Uhrzeit: this.bestellung.Uhrzeit,
                        Selbsteinkaeufer: this.bestellung.Selbsteinkaeufer,
                        Taschen: this.bestellung.Taschen,
                        Taschen_anzahl: this.bestellung.Taschen_anzahl,
                        Kisten: this.bestellung.Kisten,
                        Kisten_anzahl: this.bestellung.Kisten_anzahl,
                        Bestellbemerkung: this.blockername,
                        Shop: this.bestellung.Shop,
                        Shop_Bemerkung: this.bestellung.Shop_Bemerkung,
                        Baecker: this.bestellung.Baecker,
                        Baecker_Bemerkung: this.bestellung.Baecker_Bemerkung,
                        TK: this.bestellung.TK,
                        TK_Anmerkung: this.bestellung.TK_Anmerkung,
                        Blumen: this.bestellung.Blumen,
                        Blumen_Bemerkung: this.bestellung.Blumen_Bemerkung,
                        terminId: 0,
                        Enduhrzeit: this.bestellung.Enduhrzeit,
                        kalender: "keiner",
                        ReihenterminId: null,
                        Fahrer: this.bestellung.Fahrer,
                        auth: process.env.VUE_APP_PHP_AUTH
                    }

                    // REIHENTERMIN
                    if (this.rowtermin == 0) {
                        this.singletermin = 1
                        this.addTermin(neueBestellung)
                    } else {
                        var i = 0
                        var reihenterminId = 1 + moment.utc(this.bestellung.Datum, "YYYY-MM-DD").format("YYYYMMDD") + this.bestellung.Uhrzeit.substring(0, 2)
                        neueBestellung.ReihenterminId = reihenterminId
                        this.showAlarm = 1
                        this.addRowTermin(i, neueBestellung)
                    }
                } else {
                    alert("Bitte korrecktes Datum, Start- und End-Uhrzeit angeben!")
                    return false
                }
            },
            addTermin(neueBestellung) {
                this.$http.post(process.env.VUE_APP_PHP_API_URL + "/bestellung/add/1", neueBestellung).then(function (response) {
                    // console.log(response)
                    if (this.singletermin == 1) {
                        this.$router.push({
                            path: "/tagestour",
                            query: { alarm: "Blocker hinzugefügt!", date: this.bestellung.Datum }
                        })
                    }
                })
            },
            addRowTermin: _.debounce(function (i, termin) {
                var that = this
                this.addTermin(termin)
                var newDate = moment.utc(termin.Datum, "YYYY-MM-DD").add(this.selectedFrequency.days, "d").format("YYYY-MM-DD")
                termin.Datum = newDate

                console.log(i)
                var thisYear = moment.utc(termin.Datum, "YYYY-MM-DD").format("YYYY")
                var terminDate = new Date(termin.Datum)

                var dstEnd
                var dstStart
                for (var j = 0; j < this.dst.length; j++) {
                    if (this.dst[j].year == thisYear) {
                        dstEnd = new Date(this.dst[j].ende)
                        dstStart = new Date(this.dst[j].start)
                    }
                }

                if (terminDate < dstEnd && terminDate >= dstStart) {
                    termin.start = newDate + "T" + termin.Uhrzeit + ":00+02:00"
                    termin.ende = newDate + "T" + termin.Enduhrzeit + ":00+02:00"
                } else {
                    termin.start = newDate + "T" + termin.Uhrzeit + ":00+01:00"
                    termin.ende = newDate + "T" + termin.Enduhrzeit + ":00+01:00"
                }

                if (i < this.selectedFrequency.cycles - 1) {
                    this.addRowTermin(i + 1, termin)
                } else {
                    setTimeout(function () {
                        that.$router.push({
                            path: "/kunden",
                            query: { alarm: "Reihenblocker hinzugefügt!" }
                        })
                    }, 2000)
                }
            }, 300)
        },
        created: function () {}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #buttonbottom {
        margin-bottom: 50px;
    }
    #frame {
        margin-left: 0%;
        margin-top: 0%;
        padding-left: 0%;
        padding-top: 0%;
        padding-right: 0%;
    }
    #center {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50vh;
    }
</style>
